<h2 i18n>MEDICAL FORM</h2>
<div [formGroup]="medicalInfoService.medicalForm" class="medical-form" *ngIf="booking">

  <div class="first-column">
    <label i18n="last name">
      Last name:
    </label>
  </div>
  <div class="second-column">
    {{booking.student.lastName}}
  </div>

  <div class="first-column">
    <label i18n="first name">
      First name:
    </label>
  </div>

  <div class="second-column">
    {{booking.student.firstName}}
  </div>

  <br>
  <div class="first-column">
    <label i18n="street name of student address">
      Address: street*
    </label>
  </div>
  <div class="second-column">
    <input pInputText type="text" formControlName="streetName" id="street-name">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('streetName')!.touched && medicalInfoService.medicalForm.value.streetName == '') || 
      (submitFail && medicalInfoService.medicalForm.value.streetName == '')">
      this field can not be empty.
    </div>
  </div>
  <div class="first-column">
    <label i18n="street number of student address">
      Number*
    </label>
  </div>
  <div class="second-column">
    <input pInputText type="text" formControlName="streetNumber" id="street-number">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('streetNumber')!.touched && medicalInfoService.medicalForm.value.streetNumber == null) ||
      (submitFail && medicalInfoService.medicalForm.value.streetNumber == null)">
      this field can not be empty.
    </div>
  </div>
  <div class="first-column">
    <label i18n="city of student address">
      Locality:*
    </label>
  </div>

  <div class="second-column">
    <input pInputText type="text" formControlName="city" id="city">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('city')!.touched && medicalInfoService.medicalForm.value.city == '') || 
      (submitFail && medicalInfoService.medicalForm.value.city == '')">
      this field can not be empty.
    </div>
  </div>
  <div class="first-column">
    <label i18n="code postal like zip code of student address">
      Post code:*
    </label>
  </div>
  <div class="second-column">
    <input pInputText type="text" formControlName="postCode" id="post-code">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('postCode')!.touched && medicalInfoService.medicalForm.value.postCode == '') || 
      (submitFail && medicalInfoService.medicalForm.value.postCode == '')">
      this field can not be empty.
    </div>
  </div>

  <br>

  <div class="first-column">
    <label i18n="birth date of student with day, month and year">
      Date of birth:*
    </label>
  </div>
  <div class="second-column">
    <div class="calendar-wrap">
      <p-calendar [locale]="locale" formControlName="birthDate" [monthNavigator]="true" [yearNavigator]="true"
        yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false" id="birth-date"></p-calendar>
    </div>

    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('birthDate')!.touched && medicalInfoService.medicalForm.value.birthDate == null) || 
      (submitFail && medicalInfoService.medicalForm.value.birthDate == null)">
      this field can not be empty.
    </div>
  </div>

  <div class="first-column">
    <label i18n="start date and end date of program in Bruges">
      STAY IN BRUGES:*
    </label>
  </div>
  <div class="second-column">
    <div class="range-wrap">
      <p i18n>
        From
      </p>
      <p>
        {{booking.startDate.format("DD/MM/YYYY")}}
      </p>

      <p i18n>
        To
      </p>
      <p>
        {{booking.endDate.format("DD/MM/YYYY")}}
      </p>

    </div>

  </div>

  <label i18n="language that student will learn">
    Selected language:*
  </label>

  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="targetLanguages[0]" formControlName="targetLanguage" id="target-language-dutch">
      <p i18n="dutch">
        Dutch
      </p>
    </div>

    <div class="radio-item">
      <input type="radio" [value]="targetLanguages[1]" formControlName="targetLanguage" id="target-language-english">
      <p i18n="english">
        English
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="targetLanguages[2]" formControlName="targetLanguage" id="target-language-french">
      <p i18n="french">
        French
      </p>
    </div>
    <div i18n class="warning"
      *ngIf="(submitFail && medicalInfoService.medicalForm.value.targetLanguage == '')">
      this field can not be empty.
    </div>
  </div>
  <br>
  <div class="first-column">
    <label i18n="medical information">
      MEDICAL INFORMATION
    </label>
  </div>

  <div class="first-column">
    <label i18n="name of your doctor">
      Name of the GP:*
    </label>
  </div>
  <div class="second-column">
    <input pInputText type="text" formControlName="doctorName" id="doctor-name">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('doctorName')!.touched && medicalInfoService.medicalForm.value.doctorName == '') || 
      (submitFail && medicalInfoService.medicalForm.value.doctorName == '')">
      this field can not be empty.
    </div>
  </div>

  <label i18n="phone number of doctor">
    Tel:*
  </label>
  <div class="second-column">
    <input pInputText type="text" formControlName="doctorPhoneNumber" id="doctor-phone-number">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('doctorPhoneNumber')!.touched && medicalInfoService.medicalForm.value.doctorPhoneNumber == '') || 
      (submitFail && medicalInfoService.medicalForm.value.doctorPhoneNumber == '')">
      this field can not be empty.
    </div>
  </div>


  <label i18n="diseases student had before">
    Diseases and operations experienced:
  </label>
  <textarea pInputTextarea [autoResize]="true" formControlName="experiencedDiseases"
    id="experienced-diseases"></textarea>

  <label i18n="student had">
    Does your child suffer from
  </label>
  <div class="checkbox-list">
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasDiabetes" id="has-diabetes">
      <p i18n>
        diabetes
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasAsthma" id="has-asthma">
      <p i18n>
        asthma
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasHeartTrouble" id="has-heart-trouble">
      <p i18n>
        heart trouble
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasEpilepsy" id="has-epilepsy">
      <p i18n>
        epilepsy
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasRheumatism" id="has-rheumatism">
      <p i18n>
        rheumatism
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasPhysicalDisability" id="has-physical-disability">
      <p i18n>
        physical disability
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasSkinAffection" id="has-skin-affection">
      <p i18n>
        skin affection
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasSleepDisorder" id="has-sleep-disorder">
      <p i18n>
        sleep disorder
      </p>
    </div>
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasMentalDisorder" id="has-mental-disorder">

      <p i18n>
        mental disorder
      </p>
    </div>
  </div>
  <div *ngIf="medicalInfoService.medicalForm.value.hasMentalDisorder" class="second-column">
    <textarea i18n-placeholder formControlName="mentalDisorderDescription" placeholder="Please explain in detail" cols="30"
      rows="10" id="mental-disorder-description"></textarea>
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['mentalDisorderDescriptionMissing'] && medicalInfoService.medicalForm.get('mentalDisorderDescription')!.touched) || 
      (medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['mentalDisorderDescriptionMissing'] && submitFail)">
      Description is missing.
    </div>
  </div>

  <label i18n>
    others
  </label>
  <textarea pInputTextarea [autoResize]="true" formControlName="otherDiseases" id="other-diseases"></textarea>
  <label i18n>
    Date of the last skin test:
  </label>
  <p-calendar [locale]="locale" formControlName="lastSkinTestDate" [monthNavigator]="true" [yearNavigator]="true"
    yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false" id="last-skin-test-date"></p-calendar>
    <label i18n *ngIf="medicalInfoService.medicalForm.value.lastSkinTestDate">
      Result of skin test:*
    </label>
    <div class="radio-box" *ngIf="medicalInfoService.medicalForm.value.lastSkinTestDate">
        <div class="radio-item">
          <input type="radio" [value]="true" formControlName="skinTestPositive" id="skin-test-positive">
          <p i18n>
            Positive
          </p>
        </div>
        <div class="radio-item">
          <input type="radio" [value]="false" formControlName="skinTestPositive" id="skin-test-negative">
          <p i18n>
            Negative
          </p>
        </div>
        <div class="warning" *ngIf="(medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['skinTestResultMissing'] && medicalInfoService.medicalForm.get('skinTestPositive')!.touched) || 
        (medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['skinTestResultMissing'] && submitFail)">
          Skin test result is missing.
        </div>
      </div>
  <label i18n>
    Vaccination against tetanus?*
  </label>
  <div class="radio-box">

    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="hadTetanusVaccination" id="had-tetanus-vaccination">
      <p i18n>
        Yes
      </p>
    </div>

    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="hadTetanusVaccination" id="had-no-tetatus-vaccination">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
      *ngIf="(submitFail && medicalInfoService.medicalForm.value.hadTetanusVaccination == null)">
      this field can not be empty.
    </div>
  </div>
  <label i18n *ngIf="medicalInfoService.medicalForm.value.hadTetanusVaccination">
    Booster shot?:
  </label>
  <div class="tetanus-booster" *ngIf="medicalInfoService.medicalForm.value.hadTetanusVaccination">
    <select formControlName="tetanusBoosterYear" id="tetanus-booster-year">
      <option *ngFor="let year of years" [value]="year">{{year}}</option>
    </select>
    <p i18n>
      (year)
    </p>
  </div>

  <label i18n>
    Allergies or sensitivity to:*
  </label>

  <div class="checkbox-list">
    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasAllergiesToMedicines" id="has-allergies-to-medicines">
      <p i18n>
        Medicines
      </p>
    </div>
    <div *ngIf="medicalInfoService.medicalForm.value.hasAllergiesToMedicines">
      <label i18n>
        if yes, which ones?:*
      </label>
      <input pInputText type="text" formControlName="allergiesCauseMedicine" id="allergies-cause-medicine">
    </div>
    <div i18n class="warning"
      *ngIf="medicalInfoService.medicalForm.errors && ((medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['medicineMissing'] && medicalInfoService.medicalForm.get('allergiesCauseMedicine')!.touched) || 
      (medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['medicineMissing'] && submitFail))">
      This information can not be empty.
    </div>

    <div class="checkbox-item">
      <input type="checkbox" [value]="true" checked formControlName="hasAllergiesToSubstances" id="has-allergies-to-substances">
      <p i18n>
        Substances or foods
      </p>
    </div>
    <div *ngIf="medicalInfoService.medicalForm.value.hasAllergiesToSubstances">
      <label i18n>
        if yes, which ones?:*
      </label>
      <input pInputText type="text" formControlName="allergiesCauseSubstance" id="allergies-cause-substance">
    </div>

    <div i18n class="warning"
      *ngIf="medicalInfoService.medicalForm.errors && ((medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['substanceMissing'] && medicalInfoService.medicalForm.get('allergiesCauseSubstance')!.touched) || 
      (medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['substanceMissing'] && submitFail))">
      This information can not be empty.
    </div>
  </div>

  <label i18n>
    Is your child incontinent?*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="isIncontinent" id="is-incontinent">
      <p i18n>
        Yes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="isIncontinent" id="is-not-incontinent">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.value.isIncontinent == null && submitFail)">
      This information can not be empty.
    </div>
  </div>

  <label i18n>
    Does he/she get quickly tired?*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="isQuicklyTired" id="is-quickly-tired">
      <p i18n>
        Yes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="isQuicklyTired" id="is-not-quickly-tired">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(medicalInfoService.medicalForm.value.isQuicklyTired == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <label i18n>
    Is he/she particularly sensitive to chilling?*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="isSensitiveToChilling" id="is-sensitive-to-chilling">
      <p i18n>
        Yes
      </p>
    </div>

    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="isSensitiveToChilling" id="is-not-sensitive-to-chilling">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(medicalInfoService.medicalForm.value.isSensitiveToChilling == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <label i18n>
    Is he/she able to take part in sports and activities adapted to youths of his/her age without any risk?*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="canSportWithoutRisk" id="can-sport-without-risk">
      <p i18n>
        Yes
      </p>
    </div>

    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="canSportWithoutRisk" id="can-not-sport-without-risk">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.value.canSportWithoutRisk == null && submitFail)">
      This information can not be empty.
    </div>
  </div>
  <div *ngIf="medicalInfoService.medicalForm.value.canSportWithoutRisk == false" class="second-column">
    <textarea pInputTextarea i18n-placeholder placeholder="Please explain in detail" cols="30" rows="3" [autoResize]="true"
      formControlName="riskDescriptionToSport" id="risk-description-to-sport"></textarea>
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['riskDescriptionToSportMissing'] && medicalInfoService.medicalForm.get('riskDescriptionToSport')!.touched) || 
      (medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['riskDescriptionToSportMissing'] && submitFail)">
      Description is missing.
    </div>
  </div>

  <label i18n>
    Will he/she have to follow any medical treatment?*
  </label>
  <div class="radio-box">
    <div class="radio-item">
      <input type="radio" [value]="true" formControlName="needMedicalTreatment" id="need-medical-treatment">
      <p i18n>
        Yes
      </p>
    </div>
    <div class="radio-item">
      <input type="radio" [value]="false" formControlName="needMedicalTreatment" id="need-no-medical-treatment">
      <p i18n>
        No
      </p>
    </div>
    <div i18n class="warning"
    *ngIf="(medicalInfoService.medicalForm.value.needMedicalTreatment == null && submitFail)">
    This information can not be empty.
  </div>
  </div>

  <div *ngIf="medicalInfoService.medicalForm.value.needMedicalTreatment" class="first-column">
    <label i18n>
      If yes, which quantity?:
    </label>
  </div>
  <div *ngIf="medicalInfoService.medicalForm.value.needMedicalTreatment" class="second-column">
    <input pInputText formControlName="medicinesQuantity" id="medicines-quantity">
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['medicineDoseMissing'] && medicalInfoService.medicalForm.get('medicinesQuantity')!.touched) || 
      (medicalInfoService.medicalForm.errors && medicalInfoService.medicalForm.errors!['medicineDoseMissing'] && submitFail)">
      this field can not be empty.
    </div>
  </div>

  <label i18n>
    Blood type:*
  </label>
  <select formControlName="bloodType" id="blood-type">
    <option value="null" disabled i18n>Select groupe</option>
    <option i18n [ngValue]="bloodTypes[0]">A+</option>
    <option i18n [ngValue]="bloodTypes[1]">A-</option>
    <option i18n [ngValue]="bloodTypes[2]">B+</option>
    <option i18n [ngValue]="bloodTypes[3]">B-</option>
    <option i18n [ngValue]="bloodTypes[4]">O+</option>
    <option i18n [ngValue]="bloodTypes[5]">O-</option>
    <option i18n [ngValue]="bloodTypes[6]">AB+</option>
    <option i18n [ngValue]="bloodTypes[7]">AB-</option>
    <option i18n [ngValue]="bloodTypes[8]">I don't know</option>
  </select>
  <div class="second-column">
    <div i18n class="warning"
    *ngIf="medicalInfoService.medicalForm.value.bloodType == null && submitFail">
    This information can not be empty.
  </div>
  </div>
  <label i18n>
    Other useful informations we need to know
  </label>
  <textarea pInputTextarea [autoResize]="true" formControlName="otherInformations" cols="30" rows="3"
    id="other-infos"></textarea>

  <label i18n>
    In case you are not at home during the programme, please give us a temporary address or 
    that of another member of the family, preferably with a phone number.*
  </label>
  <div class="second-column">
    <textarea pInputTextarea [autoResize]="true" formControlName="emergencyContactAddress" cols="30" rows="5"
      id="emergency-contact"></textarea>
    <div i18n class="warning"
      *ngIf="(medicalInfoService.medicalForm.get('emergencyContactAddress')!.errors && medicalInfoService.medicalForm.get('emergencyContactAddress')!.errors!['required'] && medicalInfoService.medicalForm.get('emergencyContactAddress')!.touched) || 
      (medicalInfoService.medicalForm.get('emergencyContactAddress')!.errors && medicalInfoService.medicalForm.get('emergencyContactAddress')!.errors!['required'] && submitFail)">
      this field can not be empty.
    </div>
  </div>



</div>